import api from '../../services/service_user'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      user_list: [],
      role_list: [],
      activePage: 1,
      allItem: 0,
      ItemPerpage: 9,
      user_modal: {
        user_id: null,
        username: '',
        password: '',
        fullname: '',
        profile: null,
        role_id: 4,
        is_active: 1
      }
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.searchUser()
    },
    getRoleUser () {
      api.getRole(
        result => {
          if (result.response === true) {
            this.role_list = result.data
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    searchUser () {
      var obj = {
        search: this.search,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      this.$store.state.isLoading = true
      api.UserAll(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.user_list = result.data.pagination
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    modalUser (user) {
      if (user) {
        this.user_modal = user
      }
      // eslint-disable-next-line no-undef
      $('#FormUser').modal('show')
    },
    clearModalUser () {
      this.user_modal = {
        user_id: null,
        username: '',
        password: '',
        fullname: '',
        profile: null,
        role_id: 4,
        is_active: 1
      }
      // eslint-disable-next-line no-undef
      $('#FormUser').modal('hide')
      this.searchUser()
    },
    actionUser () {
      if (this.user_modal.user_id) {
        this.updateUSer()
      } else {
        this.newUser()
      }
    },
    newUser () {
      if (this.user_modal.password !== '' && this.user_modal.password.length > 5) {
        var obj = {
          username: this.user_modal.username,
          password: this.user_modal.password,
          fullname: this.user_modal.fullname,
          profile: '',
          role_id: this.user_modal.role_id
        }
        this.$store.state.isLoading = true
        api.addUser(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.searchUser()
              this.clearModalUser()
              Swal.fire('เพิ่มข้อมูลผู้ใช้งาน', result.data, 'success')
            } else {
              this.clearModalUser()
              Swal.fire('เพิ่มข้อมูลผู้ใช้งาน', result.data, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
        // eslint-disable-next-line no-undef
        $('#FormUser').modal('hide')
      } else {
        Swal.fire('แจ้งเตือน', 'รหัสผ่านต้องไม่น้อยกว่า 6 หลัก', 'warning')
      }
    },
    updateUSer () {
      // eslint-disable-next-line no-undef
      $('#FormUser').modal('hide')
      var obj = {
        user_id: this.user_modal.user_id,
        username: this.user_modal.username,
        password: this.user_modal.password,
        fullname: this.user_modal.fullname,
        profile: '',
        role_id: this.user_modal.role_id,
        is_active: this.user_modal.is_active
      }
      this.$store.state.isLoading = true
      api.UserUpdate(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.searchUser()
            this.clearModalUser()
            Swal.fire('แก้ไขข้อมูลผู้ใช้งาน', result.data, 'success')
          } else {
            Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    removeUser (data) {
      Swal.fire({
        title: 'ลบข้อมูลผู้ใช้งาน?',
        text: 'ท่านต้องการลบข้อมูลผู้ใช้งาน ' + data.username + ' ใช่หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          api.deleteUser(
            data.user_id,
            this.header,
            result => {
              if (result.response === true) {
                this.searchUser()
                Swal.fire('ลบผู้ใช้งาน', 'ลบผู้ใช้งานเรียบร้อยแล้ว', 'success')
              } else {
                Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  mounted () {
    this.searchUser()
    this.getRoleUser()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
    // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/users.js